import { Link } from 'react-router-dom';

const colServices = [
  { label: 'Custom Landscaping', href: '/services/hardscaping' },
  { label: 'Hardscaping & Patios', href: '/services/hardscaping' },
  { label: 'Retaining Walls', href: '/services/hardscaping' },
  { label: 'Turf Installation', href: '/services/hardscaping' },
  { label: 'French Drains', href: '/services/hardscaping' },
  { label: 'Snow Removal', href: '/services/hardscaping' },
  { label: 'Sprinkler Systems', href: '/services/hardscaping' },
];

const quickLinks = [
  { label: 'Home', href: '/' },
  { label: 'About CQC', href: '/about' },
  { label: 'Our Services', href: '/services/hardscaping' },
  { label: 'Service Areas', href: '/locations/colorado-springs' },
  { label: 'Free Estimate', href: '/#estimate' },
];

const areas = [
  { label: 'Hayden, ID', href: '/locations/colorado-springs' },
  { label: 'Post Falls', href: '/locations/colorado-springs' },
  { label: "Coeur d'Alene", href: '/locations/colorado-springs' },
  { label: 'Spokane, WA', href: '/locations/colorado-springs' },
  { label: 'Rathdrum', href: '/locations/colorado-springs' },
  { label: 'Athol, ID', href: '/locations/colorado-springs' },
];

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a]">
      {/* Top gold accent */}
      <div className="h-[2px] bg-gradient-to-r from-transparent via-gold to-transparent opacity-50"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6 cursor-pointer">
              <div className="w-11 h-11 rounded-xl bg-forest overflow-hidden flex items-center justify-center p-1.5 shrink-0">
                <img src="https://cqc-landscaping.com/wp-content/themes/land7/images/logo.jpg" alt="CQC Landscaping" className="w-full h-full object-contain" />
              </div>
              <div>
                <div className="font-serif text-base font-semibold text-white leading-none">CQC Landscaping</div>
                <div className="font-sans text-[9px] text-white/25 tracking-[0.18em] uppercase mt-0.5">Hayden, ID · Spokane, WA</div>
              </div>
            </Link>
            <p className="font-sans text-white/35 text-sm leading-relaxed mb-6">
              Premium landscaping, hardscaping, and outdoor solutions for homeowners and businesses across North Idaho and Eastern Washington.
            </p>
            <div className="flex items-center gap-2">
              <a href="https://www.facebook.com/profile.php?id=100063579296067" rel="noreferrer noopener" target="_blank"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/5 hover:bg-gold hover:text-forest transition-all cursor-pointer border border-white/8 text-white/50" aria-label="Facebook">
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a href="https://g.page/r/CZ1jxkpescjzEBM/review" rel="noreferrer noopener" target="_blank"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/5 hover:bg-gold hover:text-forest transition-all cursor-pointer border border-white/8 text-white/50" aria-label="Google Reviews">
                <i className="ri-google-fill text-sm"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-sans text-[9px] tracking-[0.22em] uppercase text-gold mb-6">Services</h4>
            <ul className="space-y-3">
              {colServices.map((s) => (
                <li key={s.label}>
                  <Link to={s.href} className="font-sans text-sm text-white/35 hover:text-white transition-colors cursor-pointer flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-gold/50 shrink-0"></span>
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links + Areas */}
          <div>
            <h4 className="font-sans text-[9px] tracking-[0.22em] uppercase text-gold mb-6">Quick Links</h4>
            <ul className="space-y-3 mb-8">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.href} className="font-sans text-sm text-white/35 hover:text-white transition-colors cursor-pointer flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-gold/50 shrink-0"></span>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
            <h4 className="font-sans text-[9px] tracking-[0.22em] uppercase text-gold mb-4">Service Areas</h4>
            <div className="flex flex-wrap gap-1.5">
              {areas.map((a) => (
                <Link key={a.label} to={a.href}
                  className="font-sans text-[11px] text-white/35 hover:text-gold border border-white/8 hover:border-gold/30 rounded-full px-3 py-1 transition-all cursor-pointer">
                  {a.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-sans text-[9px] tracking-[0.22em] uppercase text-gold mb-6">Contact</h4>
            <ul className="space-y-5">
              <li>
                <a href="tel:+12086596067" className="flex items-start gap-3 group cursor-pointer">
                  <i className="ri-phone-fill text-gold text-sm mt-0.5 shrink-0"></i>
                  <div>
                    <div className="font-sans font-bold text-white text-sm group-hover:text-gold transition-colors">(208) 659-6067</div>
                    <div className="font-sans text-white/25 text-xs">Call or text anytime</div>
                  </div>
                </a>
              </li>
              <li>
                <a href="mailto:info@cqc-landscaping.com" className="flex items-start gap-3 group cursor-pointer">
                  <i className="ri-mail-line text-white/30 text-sm mt-0.5 shrink-0"></i>
                  <div className="font-sans text-white/35 text-sm group-hover:text-white transition-colors">info@cqc-landscaping.com</div>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-2-line text-white/30 text-sm mt-0.5 shrink-0"></i>
                <div>
                  <div className="font-sans text-white/45 text-sm">Hayden, ID 83835</div>
                  <div className="font-sans text-white/25 text-xs">Serving North Idaho &amp; Spokane WA</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-white/30 text-sm mt-0.5 shrink-0"></i>
                <div>
                  <div className="font-sans text-white/45 text-sm">Mon–Sat: 7:30AM–6PM</div>
                  <div className="font-sans text-white/45 text-sm">Sun: 8:00AM–5PM</div>
                  <div className="font-sans text-gold text-xs mt-1">24/7 Emergency Available</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-14 pt-6 border-t border-white/6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-sans text-white/18 text-xs">
            &copy; {new Date().getFullYear()} CQC Landscaping · Hayden, ID · Licensed &amp; Insured
          </p>
          <Link to="/#estimate" className="whitespace-nowrap inline-flex items-center gap-2 bg-gold hover:bg-gold-light text-forest-deep font-bold text-xs rounded-full px-5 py-2.5 transition-all cursor-pointer">
            Get Free Estimate <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </footer>
  );
}
